'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { NAV, isActive, visible } from '@/components/layout/nav-config';
import { useSessionStore } from '@/lib/auth/session';
import { cn } from '@/lib/util/cn';

export function Sidebar() {
  const pathname = usePathname();
  const role = useSessionStore((s) => s.me?.role ?? null);
  const groups = NAV.map((g) => ({ ...g, items: g.items.filter((i) => visible(i, role)) })).filter(
    (g) => g.items.length > 0,
  );
  return (
    <aside
      data-app-shell="sidebar"
      className="flex h-full w-56 shrink-0 flex-col border-r border-border bg-bg-elev"
    >
      <div className="flex h-12 items-center px-4">
        <Link href="/control" className="truncate font-display text-[15px] font-semibold tracking-tight text-fg">
          Trading Engine
        </Link>
      </div>
      <nav className="flex-1 overflow-y-auto px-2 pb-4" aria-label="Primary navigation">
        {groups.map((g, gi) => (
          <div key={g.label ?? `g${gi}`} className={cn(gi > 0 && 'mt-4')}>
            {g.label ? <div className="px-2 pb-1 text-xs text-fg-subtle">{g.label}</div> : null}
            <ul className="flex flex-col">
              {g.items.map((i) => {
                const Icon = i.icon;
                const active = isActive(pathname, i.href);
                return (
                  <li key={i.href}>
                    <Link
                      href={i.href as never}
                      className={cn(
                        'flex items-center gap-2.5 rounded px-2 py-1.5 text-[13px] transition-colors',
                        active ? 'bg-surface-inset font-medium text-fg' : 'text-fg-muted hover:bg-surface-inset hover:text-fg',
                      )}
                    >
                      <Icon className={cn('h-4 w-4 stroke-[1.75]', active ? 'text-fg' : 'text-fg-subtle')} aria-hidden />
                      {i.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
}
